{
    "MainmenuPinmenu": "Menu Pin",
    "MainmenuPinnedmenu": "Menu Disinserisci",
    "MainmenuHome": "Casa",
    "MainmenuMoreoptions": "Altre opzioni",
    "MainmenuWhatisnew": "Cosa c'è di nuovo?",
    "MainmenuOmnichannelPanel": "Pannello Omnichannel",
    "MainmenuPrivacynotice": "Informativa sulla privacy",
    "MainMenuCookiePolicy": "Informativa sui cookie",
    "MainmenuTermsofservice": "Termini di servizio",
    "MainmenuSetlanguage": "Imposta lingua",
    "MainmenuHelp": "Aiuto",
    "MainmenuChangePassword": "Modifica della password",
    "MainmenuServerInfo": "Info sul server",
    "MainmenuSendfeedback": "Inviateci il vostro feedback!",
    "MainmenuButtonTitleAddreport": "Aggiungi nuovo rapporto",
    "MainmenuButtonTitleDeletereport": "Cancellare il rapporto",
    "MainmenuButtonTitlePermanentlyDeletereport": "Cancellare definitivamente il rapporto",
    "MainmenuButtonSubTitleDisabled": "(Selezionare alcuni rapporti per utilizzare questa opzione)",
    "NAME": "LanguageMainMenu",
    "MainMenu_RestartTour": "Riavviare il tour",
    "MAIN_MENU_SETTINGS_CLEAR_CONTENTFUL_CACHE": "Cancellare la cache dei contenuti",
    "MainMenu_Turn_On_Insights_Hub": "Attivare il cruscotto Insights",
    "MainMenu_Turn_Off_Insights_Hub": "Disattivare la dashboard Insights",
    "MainMenu_Timezone": "Cambia fuso orario"
}